<template>
  <div class="app-container">
    <div ref="search" class="search-content" style="margin-top: 10px;">
      <el-form :inline="true" label-position="right" label-width="100px">
        <el-form-item label="报销单编号：" style="width: 320px;">
          <el-input v-model="queryForm.reim_no" filterable clearable style="width: 180px" />
        </el-form-item>
        <el-form-item label="品牌：" style="width: 320px;">
          <el-select v-model="queryForm.brand_id" class="order-list-search-item" filterable clearable collapse-tags popper-class="select-all" style="width: 180px" @change="changeBrand">
            <el-option v-for="(v, k) in brands" :key="k" :value="v.id" :label="v.brand_en" />
          </el-select>
        </el-form-item>
        <el-form-item label="城市：" style="width: 320px;">
          <el-select v-model="queryForm.city_id" class="order-list-search-item" filterable clearable collapse-tags popper-class="select-all" style="width: 180px" @change="changeCity">
            <el-option v-for="(v, k) in cities" :key="k" :value="v.id" :label="v.city_cn" />
          </el-select>
        </el-form-item>
        <el-form-item label="商场：" style="width: 320px;">
          <el-select v-model="queryForm.market_id" filterable clearable collapse-tags popper-class="select-all" style="width: 180px" @change="changeMarket">
            <el-option v-for="(v, k) in markets" :key="k" :value="v.id" :label="v.market_cn" />
          </el-select>
        </el-form-item>
        <el-form-item label="店铺：" style="width: 320px;">
          <el-select v-model="queryForm.store_id" filterable clearable collapse-tags popper-class="select-all" style="width: 180px">
            <el-option v-for="(v, k) in shops" :key="k" :value="v.id" :label="v.name_cn" />
          </el-select>
        </el-form-item>
        <el-form-item label="报销单状态：" style="width: 320px;">
          <el-select v-model="queryForm.reim_status" class="order-list-search-item" filterable clearable collapse-tags popper-class="select-all" style="width: 180px">
            <el-option v-for="(v, k) in reimStatusList " :key="k" :value="v.k" :label="v.v" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否有签单：" style="width: 320px" v-if="preQuoteStatus != 1">
          <el-select v-model="queryForm.has_sign_ids" class="order-list-search-item" filterable clearable collapse-tags popper-class="select-all" style="width: 180px">
            <el-option v-for="(v, k) in hasBills " :key="k" :value="k" :label="v" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否预报价：" style="width: 320px">
          <el-select v-model="queryForm.pre_quote_status" class="order-list-search-item" filterable clearable collapse-tags popper-class="select-all" style="width: 180px">
            <el-option v-for="(v, k) in preQuoteStatusList " :key="k" :value="k" :label="v" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否完工：" style="width: 320px">
          <el-select v-model="queryForm.is_completed" class="order-list-search-item" filterable clearable collapse-tags popper-class="select-all" style="width: 180px">
            <el-option v-for="(v, k) in completedStatus " :key="k" :value="k" :label="v" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否创建报告：" style="width: 320px" v-if="user_id == 1 || user_id == 9">
          <el-select v-model="queryForm.sync_report_status" class="order-list-search-item" filterable clearable collapse-tags popper-class="select-all" style="width: 180px">
            <el-option v-for="(v, k) in syncReportStatus " :key="k" :value="k" :label="v" />
          </el-select>
        </el-form-item>
        <el-form-item label="完工时间：" style="width: 320px" v-if="preQuoteStatus != 1 && !subordinate_worker">
          <el-date-picker
            v-model="queryForm.select_date"
            type="datetimerange"
            style="width: 180px"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item v-if="!subordinate_worker" label="申请时间：" style="width: 320px">
          <el-date-picker
            v-model="queryForm.create_date"
            type="datetimerange"
            style="width: 180px"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item label="工作内容：" style="width: 320px">
          <el-input v-model="queryForm.ma_remark" filterable clearable style="width: 180px" />
        </el-form-item>
        <el-form-item label="" style="width: 360px">
          <el-button  type="primary" @click="queryList">查询</el-button>
          <el-button type="primary" @click="showAdd">新建</el-button>
          <el-button type="primary" @click="exportExcel">导出</el-button>
          <el-button type="primary" @click="returnPage">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-container engineer-expense">
      <el-table :data="result.list" border stripe style="width: 100%;" :height="calcHeight">
        <el-table-column label="序号" type="index" fixed min-width="50px" align="center" />
        <el-table-column label="编号" prop="code" fixed min-width="180px" align="left">
          <template slot-scope="scope">
            <div v-if="scope.row.pre_quote_status == 1" style="background-color: green; color: #FFFFFF; width: 20px; height: 20px; text-align: center; line-height: 20px; border-radius: 2px; float: left;">
              预
            </div>
            <div style="color: #3a8ee6;cursor: pointer; float: left;" @click="showDetail(scope.row)">
              <p>{{ scope.row.reim_no }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单编号" prop="supplier_order_no" fixed min-width="150px" align="center">
          <template slot-scope="scope">
            <div style="color: #3a8ee6;cursor: pointer" @click="showOrder(scope.row)">
              <p>{{ scope.row.supplier_order_no }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="create_at" fixed min-width="100px" align="center" />
        <el-table-column label="状态" prop="ea_state" fixed min-width="120px" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.reim_status_color && scope.row.reim_status_value" style="cursor: pointer" :type="colorTypes[scope.row.reim_status_color]">{{ scope.row.reim_status_value }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="品牌" prop="brand_en" min-width="100px" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.brand_en }}</span>
          </template>
        </el-table-column>
        <el-table-column label="城市" prop="city_cn" min-width="80px" align="center" />
        <el-table-column label="商场" prop="market_cn" min-width="100px" align="center" />
        <el-table-column label="店铺" prop="store_cn" min-width="100px" align="center" />
        <el-table-column label="工作内容" prop="ma_remark" min-width="260px" align="left" />
        <el-table-column label="成本" prop="total_price" min-width="100px" align="center" />
        <el-table-column label="完工日期" prop="completed_at" min-width="100px" align="center" />
        <el-table-column label="创建时间" prop="create_at" min-width="100px" align="center" />
        <el-table-column label="更新时间" prop="updated_at" min-width="100px" align="center" />
      </el-table>
      <div style="text-align: right;margin: 10px 0;">
        <el-pagination
          background
          :page-size="queryForm.page_size"
          :page-sizes="pageSizes"
          :current-page="queryForm.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="result.cnt"
          @size-change="handleListSizeChange"
          @current-change="handleListCurrentChange"
        />
      </div>
    </div>
    <el-drawer
      v-if="detailDialog"
      :title="detailPageTitle"
      :with-header="false"
      direction="rtl"
      size="70%"
      :visible.sync="detailDialog"
      :wrapper-closable="false"
      custom-class="overflow-auto"
    >
      <expense-account-detail :detail-data="detailData" :detail-page-type="detailPageType" :subordinate-worker="subordinate_worker" :close-dialog="closeDialog" @refresh="refreshData" />
    </el-drawer>
    <el-drawer
      v-if="addDetailDialog"
      :title="detailPageTitle"
      :with-header="false"
      direction="rtl"
      size="70%"
      :visible.sync="addDetailDialog"
      :wrapper-closable="false"
      custom-class="overflow-auto"
    >
      <order-reimbursement :detail-data="detailData" :pre-quote-status="preQuoteStatus" :subordinate-worker="subordinate_worker" :detail-page-type="detailPageType" :close-dialog="closeCreateDialog" />
    </el-drawer>
  </div>
</template>

<script>
import request from '@/utils/request'

import {
  getStateOptions,
  applyExpenseAccount,
  cancelApplyExpenseAccount,
  deleteDraftExpenseAccount,
  exportEngineerData
} from '@/api/ea'
import {
  getReimAllStatusList,
  getReimExcelList,
  getReimInfo,
  getRemiList,
  reimbursementList
} from "../../api/reimbursement"
import ExpenseAccountDetail from './components/expense-account-detail'
import OrderReimbursement from './components/order-reimbursement'
import {getBrandList, getCityList, getMarketList, getShopList, orderInfo} from "../../api/order";
import {downloadFile} from "../../utils/download";
import {uploadWithoutOssToken} from "../../api/util";
import OSS from "ali-oss";
import {getBaseInfo} from "../../api/user";

const COLOR_TYPES = {
  'red': 'danger',
  'yellow': 'warning',
  'blue': 'primary',
  'green': 'success'
}

export default {
  name: 'ReimbursementPc',
  components: {
    OrderReimbursement,
    ExpenseAccountDetail,
  },
  data() {
    return {
      colorTypes: COLOR_TYPES,
      addDetailDialog: false,
      reportShowDialog: false,
      loading: false,
      hasBills: {
        'n': '无',
        'y': '有'
      },
      syncReportStatus: {
        '0': '无',
        '1': '有'
      },
      completedStatus: {
        'n': '无',
        'y': '有'
      },
      preQuoteStatusList: {
        'all': '全部',
        '0': '否',
        '1': '是'
      },
      reimStatusList: [],
      shops: [],
      cities: [],
      markets: [],
      brands: [],
      queryForm: {
        create_date: [],
        select_date: [],
        states: [],
        brandIds: [],
        applyDate: [],
        completeDate: [],
        code: '',
        city: '',
        market_id: '',
        brand_id: '',
        page: 1,
        page_size: 20,
        pre_quote_status: 'all'
      },
      pageSizes: [10, 20, 30, 50, 100, 200],
      result: {
        list: [],
        cnt: 0
      },
      detailDialog: false,
      detailPageType: 'detail',
      detailPageTitle: '报销单详情',
      detailData: {},
      currentFileId: 0,
      currentFileType: '',
      preQuoteStatus: 0,
      subordinate_worker: false,
      calcHeight: '500px',
      user_id: 0,
    }
  },
  created() {
    document.title = '工人报销'
    this.calcHeight = window.outerHeight > 700 ? (window.outerHeight - 200) + 'px' : '600px'
    const showAddFlag = this.$route.query.showAdd
    if (showAddFlag === 'true') {
      this.showAdd()
    }
    if (this.$route.query.appo_task_id || this.$route.query.reim_id) {
      this.showCreateReimbursement()
    }
    if (this.$route.query.pre_quote_status) {
      this.preQuoteStatus = this.$route.query.pre_quote_status
    }
    this.user_id = localStorage.getItem('id');
    this.getBaseInfo()
    this._isMobile()
    this.queryList()
    this.getBrandList()
    this.getCityList()
    this.getStatusList()
  },
  methods: {
    getBaseInfo() {
      getBaseInfo().then((res) => {
        if (res.data.data && typeof res.data.data.subordinate_worker !== 'undefined') {
          this.subordinate_worker = res.data.data.subordinate_worker
        }
      })
    },
    showOrder(row) {
      console.log('row.......', row)
      this.$router.push({path: '/warranty_detail', query: {ma_item_id: row.ma_item_id, appo_task_id: row.appo_task_id}})
    },
    refreshData() {
      this.queryList()
    },
    getStatusList() {
      getReimAllStatusList().then((res) => {
        if (res.data.data) {
          this.reimStatusList = res.data.data
        }
      })
    },
    changeBrand(val) {
      this.searchStore()
    },
    changeMarket(val) {
      this.searchStore()
    },
    changeCity(val) {
      this.marketLists(val)
      this.searchStore()
    },
    getBrandList() {
      getBrandList().then((res) => {
        if (res.data.data) {
          this.brands = res.data.data
        }
      })
    },
    getCityList() {
      getCityList().then((res) => {
        if (res.data.data) {
          this.cities = res.data.data
        }
      })
    },
    marketLists(cityId) {
      getMarketList({city_id: cityId}).then((res) => {
        if (res.data.data) {
          this.markets = res.data.data
        }
      })
    },
    searchStore() {
      getShopList(this.queryForm).then((res) => {
        if (res.data.data) {
          this.shops = res.data.data
        }
      })
    },
    async showCreateReimbursement() {
      this.detailData = {}
      await getReimInfo({appo_task_id: this.$route.query.appo_task_id, reim_id: this.$route.query.reim_id}).then((res) => {
        if (res.data.data) {
          const data = res.data.data
          this.detailPageType = 'update'
          this.detailPageTitle = '报销单详情'
          this.detailData = data
          this.detailDialog = true
          this.$forceUpdate()
          return true
        }
      })
      this.detailPageType = 'add'
      this.detailPageTitle = '新建报销单'
      this.detailDialog = true
    },
    _isMobile() {
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if (flag) {
        this.$router.replace('/mobile/ea/engineer-expense')
      }
    },
    returnPage() {
      this.$router.push({path: 'index'})
    },
    report(row) {
      this.detailData = row
      this.reportShowDialog = true
    },
    closeDetail() {
      this.reportShowDialog = false
      this.queryList()
    },
    closeCreateDialog() {
      this.addDetailDialog = false
      this.queryList()
    },
    queryList() {
      this.queryForm.page = 1
      this.getList()
    },
    async getList() {
      this.loading = true
      const search = this.queryForm
      if (typeof this.queryForm.select_date !== 'undefined' && this.queryForm.select_date.length > 0) {
        search.completed_start_at = this.queryForm.select_date[0]
        search.completed_end_at = this.queryForm.select_date[1]
      }
      if (this.queryForm.create_date.length > 0) {
        search.reim_create_start_at = this.queryForm.create_date[0]
        search.reim_create_end_at = this.queryForm.create_date[1]
      }
      await getRemiList(search).then((res) => {
        if (res.data.data.list) {
          const data = res.data.data.list
          this.result.cnt = res.data.data.total
          this.result.list = data
        } else {
          this.result.list = []
        }
      })
    },
    handleListSizeChange: function(val) {
      this.queryForm.page = 1
      this.queryForm.page_size = val
      this.getList()
    },
    handleListCurrentChange: function(currentPage) {
      this.queryForm.page = currentPage
      this.getList()
    },
    apply(row) {
      this.loading = true
      applyExpenseAccount({ id: row.id }).then((res) => {
        if (res.data.code > 0) {
          this.$message.error(res.data.msg)
        } else {
          this.$message.success('申请成功!')
          row.ea_state = 2
          row.state_cn = '待审核'
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
      })
    },
    cancelApply(row) {
      this.loading = true
      cancelApplyExpenseAccount({ id: row.id }).then((res) => {
        if (res.data.code > 0) {
          this.$message.error(res.data.msg)
        } else {
          this.$message.success('撤销申请成功!')
          row.ea_state = 1
          row.state_cn = '草稿'
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
      })
    },
    deleteDraft(row) {
      this.$confirm('删除后无法恢复，确认删除吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        deleteDraftExpenseAccount({ id: row.id }).then((res) => {
          if (res.data.code > 0) {
            this.$message.error(res.data.msg)
          } else {
            this.$message.success('删除草稿成功!')
            for (let i = 0; i < this.result.list.length; i++) {
              if (row.id === this.result.list[i].id) {
                this.result.list.splice(i, 1)
              }
            }
          }
          this.loading = false
        }).catch((e) => {
          this.loading = false
        })
      })
    },
    async showDetail(row) {
      this.detailPageType = 'update'
      this.detailPageTitle = '报销单详情'
      this.detailData = row
      this.detailId = row.reim_id
      this.detailData = {}
      await getReimInfo({appo_task_id: row.appo_task_id, reim_id: row.reim_id}).then((res) => {
        if (res.data.data) {
          const data = res.data.data
          console.log('data.......', data)
          this.detailPageType = 'update'
          this.detailPageTitle = '报销单详情'
          this.detailData = data
          this.detailDialog = true
          this.$forceUpdate()
          return true
        }
      })
    },
    showAdd() {
      this.detailPageType = 'add'
      this.detailPageTitle = '新建报销单'
      this.addDetailDialog = true
      this.detailData = {}
    },
    async exportExcel() {
      this.loading = true
      const search = this.queryForm
      if (typeof this.queryForm.select_date !== 'undefined' && this.queryForm.select_date.length > 0) {
        search.completed_start_at = this.queryForm.select_date[0]
        search.completed_end_at = this.queryForm.select_date[1]
      }
      if (this.queryForm.create_date.length > 0) {
        search.reim_create_start_at = this.queryForm.create_date[0]
        search.reim_create_end_at = this.queryForm.create_date[1]
      }
      await getReimExcelList(search).then((result) => {
        console.log("res..........", result.data.data.list)
        if (result.data.data && result.data.data.filename) {
          uploadWithoutOssToken({ file_suffix: 'xlsx', only_download: 1 }).then(
            (res) => {
              const ossData = res.data.data
              const client = new OSS({
                region: 'oss-' + ossData.region_id,
                accessKeySecret: ossData.access_secret,
                accessKeyId: ossData.access_id,
                stsToken: ossData.secret_token,
                bucket: ossData.bucket
              })
              const filename = '报销单明细.xlsx'
              const response = {
                'content-disposition': `attachment; filename=${encodeURIComponent(
                  filename
                )}`
              }
              const url = client.signatureUrl(result.data.data.filename, {
                response
              })
              downloadFile(url, filename)
              this.exportLoading = false
            }
          )
        }
      })
    },
    closeDialog() {
      this.detailDialog = false
      this.getList()
    },
    showReport(row) {
      // 查询报告单明细
      this.detailPageType = 'detail'
      this.detailPageTitle = '报销单详情'
      this.detailData = row
      this.detailDialog = true
    },
    getPreviewList(list) {
      return list.map((item) => {
        return item.url
      })
    }
  }
}
</script>

<style scoped lang="less">
.app-container{
  height: 100%;
  width: 94%;
  margin: 0 auto;
  .inner-container{
    height: 500px;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
  }
}
.button {
  margin: 5px;
}
</style>
<style lang="less">
.el-drawer.rtl {
  overflow: auto;
}
.engineer-expense.inner-container{
  .el-card__header{
    min-height: 55px;
  }
  .el-card__body{
    flex: 1;
    display: flex;
    flex-direction: column;
    .el-table{
      flex: 1;
    }
  }
  .el-image-own{
    position: relative;
    &::after{
      content: '签收单';
      position: absolute;
      top: 6px;
      left: 2px;
      color: #409EFF;
      cursor: pointer;
      pointer-events:none;
      font-weight: 500;
    }
    &>img{
      opacity: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/reimbursement_pc.vue